import { render } from "./ShipMovement.vue?vue&type=template&id=40b74256&scoped=true"
import script from "./ShipMovement.vue?vue&type=script&lang=js"
export * from "./ShipMovement.vue?vue&type=script&lang=js"

import "./ShipMovement.vue?vue&type=style&index=0&id=40b74256&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40b74256"]])

export default __exports__